function isTopRunner(item) {
  return item && ('redirectUrl' in item || 'brandLogo' in item);
}

export { isTopRunner as i };
